const ddadosRegistrarSolicitacao = {
  Titulo: "Registrar",
  Campos: {}
}

export { ddadosRegistrarSolicitacao }
